import { render, staticRenderFns } from "./prviewPaper.vue?vue&type=template&id=f4492048&scoped=true&"
import script from "./prviewPaper.vue?vue&type=script&lang=js&"
export * from "./prviewPaper.vue?vue&type=script&lang=js&"
import style0 from "./prviewPaper.vue?vue&type=style&index=0&id=f4492048&lang=scss&scoped=true&"
import style1 from "./prviewPaper.vue?vue&type=style&index=1&id=f4492048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4492048",
  null
  
)

export default component.exports